import { AxiosError, AxiosRequestConfig } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

import { API } from './api';
import useAPIClient from './useAPIClient';
import { QueryFnData, QueryKey } from './useAPIQuery';

export default function useAPIQueries<
  URL extends API['url'] = string,
  Method extends API['method'] = 'GET',
  TData = QueryFnData<URL, Method>[]
>(
  queries: QueryKey<URL, Method>[],
  options: UseQueryOptions<
    QueryFnData<URL, Method>[],
    AxiosError,
    TData,
    QueryKey<URL, Method>[]
  > = {}
) {
  const api = useAPIClient();

  return useQuery({
    queryKey: queries,
    queryFn({ signal }) {
      return Promise.all(
        queries.map(async (queryKey) => {
          const [route, requestConfig] = queryKey as [string, AxiosRequestConfig];

          const { data } = await api.request({
            url: route,
            method: 'GET',
            signal,
            ...requestConfig,
          });

          return data;
        })
      );
    },
    ...options,
  });
}
